import React from 'react';
import { navigate } from 'gatsby-link';
import Layout from '../../components/Layout';
import './contact.scss';

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

export default class Index extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    // Aus dem Formular selbst lesen, nicht aus dem State: Ein Feld, das der
    // Besucher nicht angefasst hat, hat nie onChange ausgeloest und fehlte
    // sonst komplett im Payload - etwa das Anliegen, wenn die Vorauswahl
    // stehen bleibt. So ist der Body identisch mit dem, was Netlify ohne
    // JavaScript bekaeme, und neue Felder wirken ohne weitere Aenderung.
    const data = {};
    new FormData(form).forEach((value, key) => {
      data[key] = value;
    });

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode(data),
    })
      .then(() => navigate(form.getAttribute('action')))
      .catch((error) => alert(error));
  };

  render() {
    return (
      <Layout pageTitle="Kontakt – Heinze Pool" pagePath={this.props.location && this.props.location.pathname}>
        <div className="ContactPageRoot">
          <section className="ContactHero">
            <div className="ContactHero__media">
              <img
                src="/img/Showroom.jpeg"
                alt="Showroom von Heinze Pool in Isernhagen"
                className="ContactHero__image"
                loading="eager"
              />
              <div className="ContactHero__overlay">
                <span className="ContactHero__eyebrow">Willkommen im Showroom</span>
                <h1 className="ContactHero__title">
                  Lassen Sie uns Ihren Traum vom eigenen Pool verwirklichen.
                </h1>
                <p className="ContactHero__text">
                  Ob Neubau, Sanierung oder Wasserpflege – wir beraten Sie persönlich. Besuchen
                  Sie uns in unserem Showroom in Isernhagen und erleben Sie unsere Pools hautnah.
                </p>
                <div className="ContactHero__contacts">
                  <a className="ContactHero__contact" href="tel:05112713145">
                    <span className="ContactHero__contactLabel">Telefon</span>
                    <span className="ContactHero__contactValue">0511 2713145</span>
                  </a>
                  <a className="ContactHero__contact" href="mailto:info@heinze-pool.de">
                    <span className="ContactHero__contactLabel">E-Mail</span>
                    <span className="ContactHero__contactValue">info@heinze-pool.de</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="ContactHero__formPanel">
              <div className="ContactPage__header">
                <span className="ContactPage__eyebrow">Kontakt</span>
                <h2>Schreiben Sie uns</h2>
                <p>Hinterlassen Sie uns eine Nachricht und wir melden uns schnellstmöglich bei Ihnen zurück.</p>
              </div>
              <form
                name="contact"
                method="post"
                action="/contact/thanks/"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={this.handleSubmit}
                className="ContactPage__form"
              >
                {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
                <input type="hidden" name="form-name" value="contact" />
                <div hidden>
                  <label>
                    Nicht ausfüllen:{' '}
                    <input name="bot-field" />
                  </label>
                </div>

                <div className="ContactPage__field">
                  <label htmlFor="name">Ihr Name</label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    required={true}
                    placeholder="Max Mustermann"
                  />
                </div>

                <div className="ContactPage__fieldGroup">
                  <div className="ContactPage__field">
                    <label htmlFor="email">E-Mail Adresse</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      required={true}
                      placeholder="mail@beispiel.de"
                    />
                  </div>
                  <div className="ContactPage__field">
                    <label htmlFor="phone">Telefonnummer</label>
                    <input
                      type="tel"
                      name="phone"
                      id="phone"
                      placeholder="0123 4567890"
                    />
                  </div>
                </div>

                <div className="ContactPage__field">
                  <label htmlFor="anliegen">Ihr Anliegen</label>
                  <div className="ContactPage__select">
                    <select
                      name="anliegen"
                      id="anliegen"
                      defaultValue="Neubau eines Pools"
                    >
                      <option>Neubau eines Pools</option>
                      <option>Sanierung / Modernisierung</option>
                      <option>Abdeckung / Überdachung</option>
                      <option>Zubehör</option>
                      <option>Wasserpflege</option>
                      <option>Bewerbung</option>
                      <option>Sonstiges</option>
                    </select>
                  </div>
                </div>

                <div className="ContactPage__field">
                  <label htmlFor="message">Ihre Nachricht</label>
                  <textarea
                    name="message"
                    id="message"
                    required={true}
                    rows="6"
                    placeholder="Erzählen Sie uns von Ihrem Projekt …"
                  />
                </div>

                <div className="ContactPage__submit">
                  <button type="submit" className="ContactPage__button">
                    Nachricht senden
                  </button>
                </div>
              </form>
            </div>
          </section>
        </div>
      </Layout>
    );
  }
}
